<div class="content-wrap">
  <div class="profile-component-wrapper">
    <div class="component-header">
      <div *ngIf="loadingData" class="component-header-left">
        <h5>loading</h5>
      </div>
      <div *ngIf="!loadingData" class="component-header-left">
        <h5>{{ userObj.user_name }}</h5>
      </div>
      <div class="component-header-right">
        <button
          class="hadsup-btn hadsup-primary-dark"
          [routerLink]="['edit-profile']"
        >
          Edit account
        </button>
        <button class="hadsup-btn hadsup-btn-default" (click)="logOut()"> Log out </button>
      </div>
    </div>
    <div class="profile-body">
      <div class="profile-info-wrapper">
        <div class="profile-info-row">
          <div class="info-col">
            <h5>Contact person</h5>
            <ul *ngIf="loadingData" class="list-unstyled loading-data">
              <li>
                <span class="shimmer shimmer2y"></span>
                <strong class="shimmer shimmer2y"></strong>
              </li>
              <li>
                <span class="shimmer shimmer2y"></span>
                <strong class="shimmer shimmer2y"></strong>
              </li>
            </ul>
            <ul *ngIf="!loadingData" class="list-unstyled">
              <li>
                <span>Email:</span><strong>{{ userObj.email }}</strong>
              </li>
              <li>
                <span>Name:</span><strong>{{ userObj.user_name }}</strong>
              </li>
              <li>
                <span>Phone number:</span><strong>{{prefix}} {{phone || '-' | slice:0:2}} {{phone | slice:2:6}}
                  {{phone | slice:6:10}}</strong>
              </li>
            </ul>
          </div>
          <div class="info-col">
            <h5>Address</h5>
            <ul *ngIf="loadingData" class="list-unstyled loading-data">
              <li>
                <span class="shimmer shimmer2y"></span>
                <strong class="shimmer shimmer2y"></strong>
              </li>
              <li>
                <span class="shimmer shimmer2y"></span>
                <strong class="shimmer shimmer2y"></strong>
              </li>
            </ul>
            <ul *ngIf="!loadingData" class="list-unstyled">
              <li>
                <span>Address:</span><strong>{{ userObj.address || '-'}}</strong>
              </li>
              <li>
                <span>Street and number:</span><strong>{{ userObj.street || '-'}}</strong>
              </li>
              <li>
                <span>Town:</span><strong>{{ userObj.town  || '-'}}</strong>
              </li>
              <li>
                <span>Postcode:</span><strong>{{ userObj.postcode  || '-'}}</strong>
              </li>
              <li>
                <span>Country:</span><strong>{{ userObj.address_country  || '-'}}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>